<template>
  <div>
    <div class="document__detail">
      <div class="aside-tab">
        <el-tabs
          type="border-card"
          v-model="activeTab"
          @tab-click="handleClickTab"
        >
          <el-tab-pane label="Thông tin văn bản" name="detail">
            <div v-if="activeTab == 'detail'">
              <p class="detail__title">
                Sử dụng mẫu
              </p>
              <p class="detail__text">
                {{dataForm.dda_template_name}}
              </p>
              <p class="detail__title">
                Phân loại mẫu
              </p>
              <p class="detail__text">
                {{dataForm.dda_category_name ? dataForm.dda_category_name : ' '}}
              </p>
              <p class="detail__title">
                Tên văn bản
              </p>
              <p class="detail__text">
                {{dataForm.name ? dataForm.name : ' '}}
              </p>
              <p class="detail__title">
                Số văn bản
              </p>
              <p class="detail__text">
                {{dataForm.code ? dataForm.code : ' '}}
              </p>
              <p class="detail__title">
                Ngày hiệu lực
              </p>
              <p class="detail__text">
                {{formatDate(dataForm.effected_date)}}
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Lịch sử ký duyệt" name="history">
            <div v-if="activeTab == 'history'">
              <div
                class="user-sign"
                v-for="(item, index) in dataForm.signers"
                :key="index"
              >
                <div class="user-sign__info__status d-flex">
                  <div class="user-sign__info d-flex">
                    <el-image
                      class="user-sign__info__avatar mr-2"
                      :src="ExtensionService.urlImg + item.user_avatar + '&r=square&w=50'"
                      fit="cover"
                    />
                    <!-- <el-avatar
                      class="user-sign__info__avatar mr-2"
                      size="medium"
                      fit="fill"
                      :src="ExtensionService.urlImg + item.user_avatar"
                    ></el-avatar> -->
                    <p class="user-sign__info__name mr-2">
                      {{item.user_name}}
                    </p>
                  </div>
                  <div :class="{
                    'user-sign__status': true,
                    'user-sign__status--signed': item.status == 'SIGNED',
                    'user-sign__status--rejected': item.status == 'REJECTED',
                    'user-sign__status--new': item.status == 'NEW',
                    'user-sign__status--waiting': item.status == 'WAITING',
                    'user-sign__status--signing': item.status == 'SIGNING',
                    'user-sign__status--failed': item.status == 'SIGNED_FAILED',
                  }">
                    {{
                      item.status == 'SIGNED' ? 'Đã ký' :
                      item.status == 'REJECTED' ?'Từ chối' :
                      item.status == 'NEW' ? 'Mới' :
                      item.status == 'WAITING' ? 'Chờ ký' :
                      item.status == 'SIGNING' ? 'Đang ký' :
                      item.status == 'SIGNED_FAILED' ? 'Ký lỗi' : ''
                    }}
                  </div>
                </div>
                <div class="user-sign__note mt-3 ml-2" v-if="item.status == 'REJECTED'">
                  {{item.note}}
                </div>
                <div class="user-sign__at text-right mt-2">
                  {{formatTimeDate(item.sign_at)}}
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div></div>
      </div>
      <div class="preview">
        <div class="preview-content">
          <iframe
            :src="`https://docs.google.com/gview?embedded=true&url=${ExtensionService.urlImg + pdfId}`"
            width="100%"
            frameborder="0"
          ></iframe>
        </div>
        <div
          class="full-screen"
          @click="showFullScreen"
        >
          <p>Xem toàn màn hình</p>
        </div>
      </div>
    </div>
    <div class="button-group">
      <el-button
        type="primary"
        plain
        @click="handleClickColse"
      >
        Đóng
      </el-button>
    </div>
    <el-dialog
      class="show-full-screen"
      :visible.sync="dialogVisibleFullScreen"
      width="100%"
      top="0"
    >
      <div class="preview-content">
        <iframe
          v-if="dialogVisibleFullScreen"
          :src="`https://docs.google.com/gview?embedded=true&url=${ExtensionService.urlImg + pdfId}`"
          width="100%"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ExtensionService from '../../../../service/ExtensionService';
import MethodService from '../../../../service/MethodService';
import DraffDocumentAutoModel from './DraffDocumentAutoModel';
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi';
import DdaTemplateApi from '@/moduleApi/DdaTemplateApi';
import DdaCategoryApi from '@/moduleApi/DdaCategoryApi';
import EmployeeApi from '@/moduleApi/EmployeeApi';
import toastr from 'toastr';
export default {
  data() {
    return {
      dialogVisibleFullScreen: false,
      ExtensionService,
      activeTab: 'detail',
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      pdfId: undefined,
      currentUser: MethodService.getCurrentUser(),
    }
  },
  methods: {
    showFullScreen() {
      this.dialogVisibleFullScreen = true
    },
    async getDetailDocument(id) {
      const res = await DraffDocumentAutoApi.findById(id);
      if (res.result) {
        Promise.all([
          this.getNameTemplate(res.result.dda_template_id),
          this.getNameCategory(res.result.dda_category_id),
        ]).then((valuePromise) => {
          res.result.dda_template_name = valuePromise[0].name ? valuePromise[0].name : '';
          res.result.dda_category_name = valuePromise[1].name ? valuePromise[1].name : '';
          this.dataForm = res.result;
          this.pdfId = this.dataForm.signed_pdf_id ? this.dataForm.signed_pdf_id : this.dataForm.unsigned_pdf_id;
          this.getListSigner();
          let checkInside = (this.dataForm.readers || []).find(item => item.employee_id == this.currentUser.id)
          if (!checkInside) {
            if (!this.dataForm.readers) this.dataForm.readers = []
            this.dataForm.readers.push({
              employee_id: this.currentUser.id,
              read_at: new Date()
            })
            this.updateReaders(this.dataForm)
          }
        });
      }
    },
    updateReaders(dataForm) {
      try {
        DraffDocumentAutoApi.update(dataForm)
      } catch (error) {
        toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
      }
    },
    getListSigner(){
      let promises = this.dataForm.signers.map(async (item) => {
        const res = await EmployeeApi.findById(item.user_id);
        return res.result
      });
      Promise.all(promises).then((promisesRes) => {
        promisesRes.forEach((item, index) => {
          this.dataForm.signers[index].user_name = item.administrative_info.name.full_name;
          this.dataForm.signers[index].user_avatar =
            item.image_id ? item.image_id : item.administrative_info.avatar_id ? item.administrative_info.avatar_id : '';
        });
      })
    },
    async getNameTemplate(id) {
      const res = await DdaTemplateApi.findById(id);
      return res.result

    },
    async getNameCategory(id) {
      const res = await DdaCategoryApi.findById(id);
      return res.result
    },
    handleClickTab(tab, event) {
      this.activeTab = tab.name;
    },
    formatTimeDate(date) {
      return MethodService.formatDate(date, "timedate");
    },
    formatDate(date) {
      return MethodService.formatDate(date, "date");
    },
    handleClickColse() {
      // this.$router.push({
      //   name: "Admin-DocumentDrafting-list"
      // }).catch((err) => {});
      this.$router.go(-2)
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getDetailDocument(this.$route.params.id);
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .document__detail {
  padding: 30px 5px 0 32px;
  display: flex;
  .aside-tab {
  width: 400px;
    .el-tabs {
      .el-tabs__header {
        border-bottom: none;
        .el-tabs__nav {
          width: 380px;
          .el-tabs__item {
            margin-left: 0;
            font-family: 'LexendDeca Regular';
            transition: all .3s cubic-bezier(.645,.045,.355,1);
            border: 1px solid transparent;
            margin-top: -1px;
            font-weight: 500;
            color: #575757;
            background-color: transparent;
            margin-top: 5px;
            margin-right: 0;
            width: 190px;
            text-align: center;
            font-size: 15px;
            &:hover {
              border-radius: 0;
              background-color: #fff;
              color: #575757 !important;
              font-weight: 600;
              border: 2px solid #9DB4D7;
              // border-bottom: 0 solid #fff;
            }
            &.is-active {
              border-radius: 0;
              background-color: #fff;
              color: #575757 !important;
              font-weight: 600;
              border: 2px solid #9DB4D7;
              border-bottom: 0 solid #fff;
            }
          }
        }
      }
      .el-tabs__content {
        word-break: break-word;
        border: 2px solid #9DB4D7;
        margin-top: -3px;
        height: calc(100vh - 223px);
        overflow-y: auto;
        .el-tab-pane {
          padding-top: 25px;
          .detail__title {
            font-family: 'UTM Avo';
            font-weight: 600;
            font-size: 17px;
            line-height: 30px;
            color: #575757;
          }
          .detail__text {
            font-family: 'UTM Avo';
            font-weight: 400;
            font-size: 17px;
            line-height: 25px;
            color: #575757;
            margin-left: 15px;
            margin-top: 10px;
            margin-bottom: 15px;
          }
          .user-sign {
            font-family: 'LexendDeca Regular';
            margin-bottom: 23px;
            .user-sign__info__status {
              align-items: center;
              justify-content: space-between;
              .user-sign__info {
                align-items: center;
                width: 100%;
                &__avatar {
                  flex-basis: 40px;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                }
                &__name {
                  flex-basis: 180px;
                  font-weight: 500;
                  font-size: 16px;
                  line-height: 22px;
                }
              }
              .user-sign__status {
                min-width: 80px;
                height: 25px;
                border-radius: 5px;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                &--signed {
                  background: #00D1FF;
                }
                &--rejected {
                  background: #FF4A6A;
                }
                &--new {
                  background: #b9b9b9;
                }
                &--waiting {
                  background: #f2efa9;
                  color: #6B3131;
                }
                &--signing{
                  background: #00D1FF;
                }
                &--failed {
                  background: #FF4A6A;
                }
              }
            }
            .user-sign__note {
              font-weight: 400;
              font-size: 16px;
              line-height: 22px;
              color: #575757;
              word-break: break-word;
            }
            .user-sign__at {
              font-weight: 300;
              font-size: 13px;
              line-height: 15px;
              color: #706E6E;
            }
          }
        }
      }
    }
  }
  .preview {
    margin-left: 25px;
    width: 100%;
    position: relative;
    .preview-content {
      iframe {
        height: calc(100vh - 180px);
      }
    }
    .full-screen {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      height: 50px;
      background: #292D32;
      opacity: 0.8;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
      p {
        color: #fff;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
}
::v-deep .show-full-screen {
  .el-dialog {
    margin-bottom: 0;
    border-radius: 0;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      max-height: calc(100vh - 2px);
      overflow: auto;
      .preview-content {
        .editor {
          background: #D0D5D9;
        }
        iframe {
          height: calc(100vh - 47px);
        }
      }
    }
  }
}
.button-group {
  margin-top: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
